import React from 'react';
import { Box, Grid, Icon, Tooltip } from '@beeline.com/bp-design-system';
import type { Fields } from '../../../types';
import { type Column } from '../../../ReactDataGrid';

export const generateColumns = <T extends string>(fields: Fields<T>) =>
  fields.map(
    (column): Column<string> => ({
      key: column.key as string,
      name: column.label,
      minWidth: 150,
      headerRenderer: (): JSX.Element => (
        <Grid gap={1} container direction="row" alignItems="center" position="relative">
          <Box flex={1} overflow="hidden" textOverflow="ellipsis" whiteSpace={'nowrap'}>
            <Tooltip title={column.label} variant="dark" placement="top" arrow>
              <span>{column.label}</span>
            </Tooltip>
            {column.description && (
              <Tooltip
                tooltipTargetProps={{ style: { verticalAlign: 'middle', marginLeft: 8 } }}
                placement="top"
                arrow
                title={column.description}
              >
                <Icon size={20} name="info" />
              </Tooltip>
            )}
          </Box>
        </Grid>
      ),
      formatter: ({ row }): any => (
        <Box minWidth="100%" minHeight="100%" overflow="hidden" textOverflow="ellipsis">
          {row[column.key as number]}
        </Box>
      )
    })
  );
